export const MENU_ITEMS_PATH_MAPPING = {
  MENU_SUBMISSION_MANAGEMENT: ['credit-creation-reports', 'compliance-report', 'complimentary-compliance-report'],
};
